<template>
  <div>
    <vxe-grid
      ref="table"
      size="mini"
      cell-class-name="align-top"
      resizable
      auto-resize
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
    >
      <template v-slot:displayImage="{ row: { defaultImageUrl } }">
        <el-image
          :src="defaultImageUrl || '/image/static/img/nopic.jpg'"
          :preview-src-list="[defaultImageUrl || '/image/static/img/nopic.jpg']"
          style="width:66px; height:66px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 66px; height: 66px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:displayName="{ row }">
        <TableLabel :value="row.goodsName" />
        <TableLabel :value="row.goodsNameEn" />
        <TableLabel
          :label="'SIZE'"
          labelKey="table_label_goodsSize"
          :value="row.goodsSize"
        />
        <TableLabel
          :label="'COLOR'"
          labelKey="table_label_goodsColor"
          :value="`${row.goodsColor || ''} ${row.goodsColorEn || ''}`"
        />
      </template>
      <template v-slot:displayNo="{ row }">
        <TableLabel
          :label="'NC'"
          labelKey="table_label_ncNo"
          :value="row.ncNo"
        />
        <TableLabel
          :label="'SKU'"
          labelKey="table_label_evgSkuNo"
          :value="row.evgSkuNo"
        />
        <TableLabel
          :label="'UPC'"
          labelKey="table_label_eanCode"
          :value="row.eanCode"
        />
      </template>
      <template v-slot:displayChannel="{ row }">
        <TableLabel
          :label="'Item'"
          labelKey="table_label_channelItemNo"
          :value="row.channelItemNo"
        />
        <TableLabel
          :label="'SKU'"
          labelKey="table_label_channelSkuNo"
          :value="row.channelSkuNo"
        />
        <TableLabel
          :label="'UPC'"
          labelKey="table_label_channelEanNo"
          :value="row.channelEanNo"
        />
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
import { format } from '@/libs/util.number.js'
import TableLabel from './label.vue'
export default {
  components: { TableLabel },
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      format: (n) => format(n),
      tableColumns: tableColumns(this),
    }
  },
}
</script>
